<template>
  <div
    id="employer-poland-page-tariff-lists"
    class="structured-description__diff-lists-block container-inner container-content"
  >
    <h2 class="structured-description__title-md">{{ title }}</h2>

    <div class="structured-description__block-content mt-12">
      <div>
        <h3 class="structured-description__diff-lists-block-subtitle _blue">
          {{ firstDataItem.title }}
        </h3>

        <div class="structured-description__packet">
          <img width="86" height="86" :src="require('../../assets/img/structured-description/calendar.png')" alt="">

          <div>
            <div class="structured-description__packet-title">{{ firstDataItem.subtitle }}</div>
            <div class="structured-description__packet-price _blue">{{ firstDataItem.price }}</div>
          </div>
        </div>

        <div class="structured-description__register-gifts-list">
          <div
            v-for="(item, index) in firstDataItem.items"
            :key="index"
            class="structured-description__list-marked-item"
          >
            <div class="structured-description__list-marked-item-icon">
              <BaseSvg name="ico-check" width="1.9rem" height="1.5rem" />
            </div>
            <div>
              {{ item }}
            </div>
          </div>
        </div>
        <div class="structured-description__activate-btn-footer mt-15">
          <router-link-modified
            class="base-btn base-btn--blue _group-action-btn-blue"
            :to="firstDataItem.button.url"
          >
            {{ firstDataItem.button.text }}
          </router-link-modified>
        </div>
      </div>

      <div>
        <h3 class="structured-description__diff-lists-block-subtitle _green">
          {{ secondDataItem.title }}
        </h3>

        <div class="structured-description__packet">
          <img width="86" height="86" :src="require('../../assets/img/structured-description/group-2p.svg')" alt="">

          <div>
            <div class="structured-description__packet-title">{{ secondDataItem.subtitle }}</div>
            <div class="structured-description__packet-price">{{ secondDataItem.price }}</div>
          </div>
        </div>
        <div class="structured-description__benefits-list">
          <div
            v-for="(benefit, index) in secondDataItem.items"
            :key="index"
            class="structured-description__list-benefit-item"
          >
            {{ benefit }}
          </div>
        </div>
        <div class="structured-description__activate-btn-footer mt-15">
          <a
            class="base-btn base-btn--green _group-action-btn-green"
            :href="secondDataItem.button.url"
            @click.prevent="$emit('click:right-activate-btn')"
          >
            {{ secondDataItem.button.text }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StructuredDescriptionDiffListsBlocks',
  props: {
    title: {
      type: String,
      default: '',
    },
    firstDataItem: {
      type: Object,
      default: () => ({}),
    },
    secondDataItem: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
